<template>
	<div class="multiselect-with-icon" :type="type" :iconBackground="iconBackground">
		<slot />
	</div>
</template>
<script>
import { defineComponent } from "vue";

export default defineComponent({
	name: "MultiselectWithIcon",
	props: {
		iconBackground: {
			type: String,
			default: "transparent",
			validator(value) {
				return ["transparent", "filled", "light"].includes(value);
			}
		},
		type: {
			type: String,
			default: "curved",
			validator(value) {
				return ["curved", "rounded"].includes(value);
			}
		}
	}
});
</script>
<style lang="scss">
@mixin multiselectWithIcon($filled, $light) {
	div.multiselect-with-icon {
		&[iconBackground="filled"] {
			background: $filled;
		}
		&[iconBackground="transparent"] {
			background: transparent;
		}
		&[iconBackground="light"] {
			background: $light;
		}
	}
}

div.multiselect-with-icon {
	display: flex;
	align-items: center;

	padding-left: 8px;
	&[type="curved"] {
		border-radius: 4px;
	}

	&[type="rounded"] {
		border-radius: 18px;
	}
	> div.icon-container {
		outline: none;
		&:not([disabled])[effects] {
			&:active,
			&:focus {
				&:before {
					background-color: transparent;
					transform: scale(1);
				}
			}
		}
	}
	> * {
		&:last-child {
			margin-left: 8px;
		}
	}
	div.multiselect {
		> div.multiselect__tags {
			border-top-left-radius: 0px;
			border-bottom-left-radius: 0px;
		}
	}
}

@include multiselectWithIcon(var(--dashboard-input), var(--dashboard-element-light));

.sideout-container {
	@include multiselectWithIcon(var(--slideout-input), var(--dashboard-element-light));
}
</style>
